<template>
  <div>
    <v-container class="fill-height">
      <v-row align="center" justify="center">
        <v-col xl="4" lg="5" md="6">
          <v-card outlined>
            <v-card-text>
              <v-row align="center" justify="start" dense>
                <v-col cols="auto" class="text-right">
                  <v-avatar color="grey" size="46">
                    <span class="text-h4 white--text title font-weight-regular"
                      >{{ getInitials(user.full_name) }}
                    </span>
                  </v-avatar>
                </v-col>
                <v-col class="text-left d-flex flex-column">
                  <span class="black--text font-weight-bold">
                    {{ user.full_name }}
                  </span>
                  <span class="">
                    {{ user.email }}
                  </span>
                </v-col>
                <v-col cols="auto" class="text-right">
                  <p style="padding: 0; margin: 0">Fecha de corte:</p>
                  <p
                    class="text-subtitle-1"
                    style="padding: 0; margin: 0; font-weight: 500"
                  >
                    {{ hasOnDemandPlan ? 'Bajo demanda' : user.payment_date }}
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-progress-linear
              color="primary"
              height="5"
              indeterminate
              v-if="isLoadingUpdateRechargeWallet"
            ></v-progress-linear>
          </v-card>
        </v-col>
      </v-row>

      <!-- Recharge Wallet -->
      <v-row align="center" justify="center" v-if="showWalletRechargeCard">
        <v-col xl="4" lg="5" md="6">
          <v-card outlined>
            <v-card-text>
              <div>
                <p class="text-subtitle-1 mb-0" style="font-weight: 600">
                  Recarga de wallet
                </p>
                <p v-if="canAddWalletRecharge">
                  Si deseas agregar fondos a tu wallet primero agrega el monto a
                  recargar y después selecciona el método de pago.
                </p>
                <v-btn
                  depressed
                  outlined
                  rounded
                  block
                  color="green darken-2"
                  class="font-weight-bold mt-4"
                  v-if="canAddWalletRecharge"
                  @click="handleOpenAddRechargeWalletModal"
                  :loading="isLoadingUpdateRechargeWallet"
                >
                  Agregar recarga
                </v-btn>
                <p v-if="canRemoveWalletRecharge">
                  Agregaste una recarga de wallet.
                </p>
                <v-btn
                  depressed
                  outlined
                  rounded
                  block
                  color="error"
                  class="font-weight-bold mt-4"
                  v-if="canRemoveWalletRecharge"
                  @click="handleRemoveRechargeWallet"
                  :loading="isLoadingUpdateRechargeWallet"
                >
                  Remover recarga
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Payment Exists -->
      <v-row
        align="center"
        justify="center"
        v-if="payment && !isLoadingUpdateRechargeWallet"
      >
        <v-col xl="4" lg="5" md="6">
          <v-progress-linear
            color="primary"
            height="5"
            indeterminate
            v-if="showChangePlanModal ? false : isLoadingChangePlan"
          ></v-progress-linear>
          <base-error
            class="mt-3"
            :errors="showChangePlanModal ? null : error"
          ></base-error>
          <v-card outlined class="py-3">
            <v-card-text>
              <div class="text-center">
                <div class="d-flex align-center justify-center">
                  <span class="text-h4 mb-0 mr-2 black--text">$</span>
                  <span class="text-h3 mb-0 black--text font-weight-regular">{{
                    formatCurrency(payment.amount)
                  }}</span>
                </div>
                <div class="text-subtitle-1 text-uppercase">Total</div>
                <v-simple-table class="">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="text-left">
                          Plan {{ getPlanName(user.plan) }}
                        </td>
                        <td class="text-right">
                          {{
                            hasOnDemandPlan
                              ? ''
                              : formatCurrency(payment.breakdown.plan_value)
                          }}
                        </td>
                      </tr>
                      <tr @click="showBalanceCard = !showBalanceCard">
                        <td class="text-left">
                          {{ walletText(payment.breakdown.wallet_balance) }}
                          <v-btn icon small>
                            <v-icon color="grey" size="16"
                              >mdi-information-outline</v-icon
                            ></v-btn
                          >
                        </td>
                        <td class="text-right">
                          {{ formatCurrency(payment.breakdown.wallet_balance) }}
                        </td>
                      </tr>
                      <tr v-if="!hasOnDemandPlan">
                        <td class="text-left">Cuota de reconexión</td>
                        <td class="text-right">
                          {{
                            formatCurrency(payment.breakdown.reconnection_fee)
                          }}
                        </td>
                      </tr>
                      <tr v-if="!hasOnDemandPlan">
                        <td class="text-left">IVA 16%</td>
                        <td class="text-right">
                          {{ formatCurrency(payment.breakdown.taxes) }}
                        </td>
                      </tr>
                      <tr v-if="hasOnDemandPlan">
                        <td class="text-left">Recarga</td>
                        <td class="text-right">
                          {{ formatCurrency(payment.breakdown.recharge) }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-fade-transition>
                  <v-card
                    outlined
                    width="100%"
                    class="text-left mt-4"
                    v-if="showBalanceCard"
                  >
                    <v-card-text>
                      <ul>
                        <li>
                          <strong>Saldo por pagar de wallet:</strong> Es el
                          saldo que debes a Pronto por todos los viajes que
                          realizaste en efectivo y por los que recibiste $3
                          pesos por cada uno.
                        </li>
                        <li class="mt-3">
                          <strong>Saldo a favor de wallet:</strong> Es el saldo
                          que tienes a favor y que Pronto te debe. Recuerda
                          completar los datos de cuenta bancaria en la
                          aplicación y todos los lunes a partir del 20 de agosto
                          2020 se harán los depósitos. Solo si tienes activado
                          el pagar la membresía con wallet.
                        </li>
                      </ul>
                    </v-card-text>
                  </v-card>
                </v-fade-transition>
                <div v-if="payment.payments.length > 0">
                  <div class="text-center mt-4">
                    <v-btn
                      outlined
                      color="primary"
                      small
                      @click="showPayments = !showPayments"
                    >
                      Ocultar historial de pagos
                      <v-icon right>mdi-menu-down</v-icon></v-btn
                    >
                  </div>
                  <v-fade-transition>
                    <v-card
                      outlined
                      width="100%"
                      class="text-left mt-4"
                      v-if="showPayments"
                    >
                      <v-card-text>
                        <v-simple-table class="mt-3">
                          <template v-slot:default>
                            <thead>
                              <th>Método</th>
                              <th class="text-center">Estatus</th>
                              <th class="text-right">Importe</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(payment, index) in payment.payments"
                                :key="index"
                              >
                                <td>
                                  {{ paymentGateway(payment.payment_gateway) }}
                                </td>
                                <td class="text-center">
                                  {{ paymentStatus(payment.status) }}
                                </td>
                                <td class="text-right">
                                  {{ formatCurrency(payment.amount) }}
                                </td>
                                <td class="text-right">
                                  <v-btn
                                    outlined
                                    x-small
                                    color="primary"
                                    :to="{
                                      name: 'oxxo-payment'
                                    }"
                                    v-if="
                                      payment.status === 'PENDING' &&
                                      (payment.payment_gateway ===
                                        'OXXO_CONEKTA' ||
                                        payment.payment_gateway ===
                                          'OXXO_FEMSA')
                                    "
                                  >
                                    Ver referencia
                                  </v-btn>
                                  <v-btn
                                    outlined
                                    x-small
                                    color="primary"
                                    :to="{
                                      name: 'spei-payment'
                                    }"
                                    v-if="
                                      payment.status === 'PENDING' &&
                                      payment.payment_gateway === 'SPEI_CONEKTA'
                                    "
                                  >
                                    Ver CLABE
                                  </v-btn>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table></v-card-text
                      >
                    </v-card>
                  </v-fade-transition>
                </div>
              </div>

              <!-- <v-btn
                  large
                  depressed
                  rounded
                  block
                  color="primary"
                  class="font-weight-bold"
                  :to="{ name: 'credit-card-payment' }"
                  >Pago con tarjeta de crédito/débito</v-btn
                > -->

              <!-- Button to change plan -->
              <v-btn
                depressed
                outlined
                rounded
                block
                color="primary"
                class="font-weight-bold mt-4"
                v-if="canChangePlan"
                @click="handleOpenChangePlanModal"
              >
                Cambiar plan
              </v-btn>
            </v-card-text>
          </v-card>
          <v-card v-if="payment.payments.length == 0" outlined class="mt-1">
            <v-card-text>
              <p class="text-subtitle-1 mb-0" style="font-weight: 600">
                Proceder al pago
              </p>
              <p>*Asegúrate de que la información de tu plan es correcta.</p>

              <v-row>
                <v-col cols="12" sm="6">
                  <v-card
                    class="fill-height"
                    style="border: 1px solid lightgray"
                  >
                    <v-card-text
                      class="d-flex flex-column justify-space-between fill-height"
                    >
                      <div>
                        <p
                          class="text-subtitle-1 my-0"
                          style="font-weight: 500"
                        >
                          Pago con SPEI
                        </p>
                        <p class="text-caption mt-0 green--text">
                          (Recomendado)
                        </p>
                      </div>
                      <ul class="px-3">
                        <li class="text-caption">Sin comisiones.</li>
                        <li class="text-caption">Se refleja de inmediato.</li>
                      </ul>
                      <div>
                        <v-btn
                          rounded
                          block
                          color="secondary"
                          class="font-weight-bold mt-4"
                          @click="askPaymentConfirmation('SPEI')"
                          >Pagar con SPEI</v-btn
                        >
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-card outlined style="border: 1px solid lightgray">
                    <v-card-text>
                      <p class="text-subtitle-1 mt-0" style="font-weight: 500">
                        Pago en OXXO
                      </p>

                      <ul class="px-3">
                        <li class="text-caption">
                          Comisión por pago de servicios.
                        </li>
                        <li class="text-caption">
                          Se reflejará en aproximadamente 20 horas o más.
                        </li>
                      </ul>
                      <v-btn
                        depressed
                        rounded
                        block
                        color="error"
                        class="font-weight-bold w-auto mt-4"
                        @click="askPaymentConfirmation('OXXO')"
                        >Pagar en OXXO</v-btn
                      >
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Payment Not Exists -->
      <v-row
        align="center"
        justify="center"
        v-else-if="!isLoadingUpdateRechargeWallet"
      >
        <v-col xl="4" lg="5" md="6">
          <v-progress-linear
            color="primary"
            height="5"
            indeterminate
            v-if="showChangePlanModal ? false : isLoadingChangePlan"
          ></v-progress-linear>
          <v-card outlined class="py-5">
            <v-card-text>
              <div class="text-center mb-4">
                <div>
                  <v-avatar size="48" class="success-icon">
                    <v-icon dark size="32" color="primary">mdi-check</v-icon>
                  </v-avatar>
                </div>
                <div class="text-h5 mb-0 black--text mt-5">
                  No tienes pagos pendientes
                </div>
                <!-- Button to change plan -->
                <v-btn
                  depressed
                  outlined
                  rounded
                  block
                  color="primary"
                  class="font-weight-bold mt-4"
                  v-if="canChangePlan"
                  @click="handleOpenChangePlanModal"
                >
                  Cambiar plan
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Modal to add wallet recharge -->
    <v-dialog
      v-model="showAddRechargeWalletModal"
      max-width="500"
      @click:outside="handleCloseAddRechargeWalletModal"
    >
      <v-card>
        <v-progress-linear
          color="primary"
          height="5"
          indeterminate
          v-if="isLoadingUpdateRechargeWallet"
        ></v-progress-linear>
        <v-card-title>
          <span>Agregar recarga de wallet</span>
        </v-card-title>
        <v-card-text>
          <base-error :errors="error"></base-error>

          <div class="d-flex align-center justify-center my-4">
            <v-btn
              depressed
              outlined
              rounded
              color="primary"
              class="font-weight-bold"
              :disabled="rechargeAmount <= 100"
              @click="rechargeAmount -= 100"
            >
              <v-icon dark size="32" color="primary">mdi-minus</v-icon>
            </v-btn>

            <div class="d-flex align-center justify-center px-8">
              <span class="text-h5 mb-0 mr-2 black--text">$</span>
              <span class="text-h4 mb-0 black--text font-weight-regular">{{
                formatCurrency(rechargeAmount || 0)
              }}</span>
            </div>

            <v-btn
              depressed
              outlined
              rounded
              color="primary"
              class="font-weight-bold"
              :disabled="rechargeAmount >= 5000"
              @click="rechargeAmount += 100"
            >
              <v-icon dark size="32" color="primary">mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="handleCloseAddRechargeWalletModal"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="
              !rechargeAmount || rechargeAmount < 15 || rechargeAmount > 5000
            "
            @click="confirmAddRechargeWallet"
            :loading="isLoadingUpdateRechargeWallet"
          >
            Listo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal to change plan -->
    <v-dialog
      v-model="showChangePlanModal"
      max-width="500"
      @click:outside="handleCloseChangePlanModal"
    >
      <v-card>
        <v-card-title>
          <span>Seleccionar nuevo plan</span>
          <v-progress-linear
            color="primary"
            height="5"
            indeterminate
            v-if="isLoadingChangePlan"
          ></v-progress-linear>
        </v-card-title>
        <v-card-text>
          <base-error :errors="error"></base-error>
          <v-select
            v-model="selectedPlan"
            :items="availablePlans"
            item-text="name"
            item-value="id"
            label="Elige un plan"
            outlined
          ></v-select>
          <div style="margin-top: -14px" v-if="selectedPlan">
            <div class="text-subtitle-1">Detalles del plan:</div>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text-left">Precio:</td>
                    <td class="text-right">
                      ${{ formatCurrency(currentPlan.price) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Cuota de reconexión:</td>
                    <td class="text-right">
                      ${{ formatCurrency(currentPlan.reconnection_fee) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Plazo:</td>
                    <td class="text-right">
                      {{ collectionRates[currentPlan.collection_rate] }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="px-4 pt-1" style="border-top: solid 1px lightgray">
              <span class="black--text">Días de trabajo:</span>

              <p>
                {{ currentPlan.workdays.map((d) => weekDays[d]).join(', ') }}
              </p>
            </div>

            <div class="px-4 pt-1" style="border-top: solid 1px lightgray">
              <span class="black--text">Descripción:</span>

              <p>{{ currentPlan.description }}</p>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="handleCloseChangePlanModal">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="!selectedPlan"
            @click="confirmPlanChange"
          >
            Listo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmation dialog to change plan -->
    <v-dialog v-model="confirmPlanDialog" max-width="400">
      <v-card>
        <v-card-title>Confirmar cambio de plan</v-card-title>
        <v-card-text>
          ¿Estás seguro/a de que deseas cambiar al
          <strong>Plan {{ currentPlan && getPlanName(currentPlan) }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="confirmPlanDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" text @click="updatePlan"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmation dialog to select payment method -->
    <v-dialog v-model="confirmPaymentMethodDialog" max-width="500">
      <v-card>
        <v-card-title>Confirmar método de pago</v-card-title>
        <v-card-text class="text-body-1">
          ¿Estás seguro/a de que deseas pagar con
          <strong>{{ selectedPaymentMethod }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="confirmPaymentMethodDialog = false"
            >Cancelar</v-btn
          >
          <v-btn color="primary" text :to="paymentRoute">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { to } from '@/helpers'
import { paymentGateways, paymentStatus } from '@/enums'
import { DriverService, PaymentService } from '@/api/api.service'
import { SESSION_UPDATE_PLAN } from '@/store/actions.type'
import { SESSION_SET_PAYMENT } from '@/store/mutations.type'
import { pathOr } from '@/helpers/functional'

export default {
  props: {},
  data() {
    return {
      error: null,
      isLoadingChangePlan: false,
      showBalanceCard: false,
      showPayments: true,
      confirmPaymentMethodDialog: false,
      selectedPaymentMethod: '',
      showChangePlanModal: false,
      confirmPlanDialog: false,
      selectedPlan: null,
      fetchedPlans: [],
      isLoadingUpdateRechargeWallet: false,
      rechargeAmount: null,
      showAddRechargeWalletModal: false,
      weekDays: {
        MONDAY: 'Lunes',
        TUESDAY: 'Martes',
        WEDNESDAY: 'Miércoles',
        THURSDAY: 'Jueves',
        FRIDAY: 'Viernes',
        SATURDAY: 'Sábado',
        SUNDAY: 'Domingo'
      },
      collectionRates: {
        MONTHLY: 'Mensual',
        WEEKLY: 'Semanal',
        DAILY: 'Diario',
        FIFTEEN_DAYS: 'Quincenal',
        ON_DEMAND: 'Bajo demanda'
      }
    }
  },
  computed: {
    ...mapGetters({ user: 'getSessionUser', payment: 'getSessionPayment' }),
    canChangePlan() {
      if (this.payment && this.payment.id) return false
      return this.availablePlans.length > 0
    },
    currentPlan() {
      return this.getPlanById(this.selectedPlan)
    },
    availablePlans() {
      return this.fetchedPlans.filter((p) => p.id !== this.user.plan.id)
    },
    hasOnDemandPlan() {
      return this.user.plan.collection_rate === 'ON_DEMAND'
    },
    showWalletRechargeCard() {
      if (!this.hasOnDemandPlan) return false
      if (this.payment && this.payment.id) return false

      return true
    },
    canAddWalletRecharge() {
      if (!this.hasOnDemandPlan) return false
      if (this.payment) {
        return this.payment.breakdown.recharge == 0
      }
      return true
    },
    canRemoveWalletRecharge() {
      if (!this.hasOnDemandPlan) return false
      if (this.payment) {
        return this.payment.breakdown.recharge > 0
      }
      return false
    },
    paymentRoute() {
      const name =
        this.selectedPaymentMethod === 'SPEI' ? 'spei-payment' : 'oxxo-payment'
      const query = {}

      if (this.payment && this.payment.breakdown.recharge > 0 && this.rechargeAmount) {
        query.recharge_amount = this.rechargeAmount
      }
      return { name, query }
    }
  },
  mounted() {
    this.getPendingPayment()
    this.fetchAvailablePlans()
  },
  methods: {
    getInitials(displayName) {
      if (!displayName) return ''
      return displayName.charAt(0)
    },
    getPlanName(plan) {
      if (plan.products.length == 0) return ''
      let planName = plan.name
      if (planName.toLowerCase().includes('plan')) {
        planName = planName.replace('plan', '').trim()
        planName = planName.replace('Plan', '').trim()
        return planName.charAt(0).toUpperCase() + planName.slice(1)
      }
      return planName
    },
    getPlanById(planId) {
      const plan = this.fetchedPlans.find((p) => p.id === planId)
      return plan ? plan : null
    },
    getPlanDescriptionById(planId) {
      const plan = this.fetchedPlans.find((p) => p.id === planId)
      return plan ? plan.description : ''
    },
    handleCloseChangePlanModal() {
      this.loading = false
      this.showChangePlanModal = false
      this.selectedPlan = null
      this.error = null
    },
    handleOpenChangePlanModal() {
      this.loading = false
      this.showChangePlanModal = true
      this.error = null
    },
    confirmPlanChange() {
      this.confirmPlanDialog = true
    },
    async fetchAvailablePlans() {
      if (this.payment && this.payment.breakdown.recharge > 0) return
      if (this.payment && this.payment.id) return

      this.isLoadingChangePlan = true
      if (this.user.plan.products.length > 0) {
        console.log('fetching available plans')
        const [
          err,
          {
            data: { data }
          }
        ] = await to(DriverService.getAvailablePlans())
        if (err) {
          this.error = this.$t('errors.unknownError')
        } else {
          this.fetchedPlans = data.plans.filter(
            (p) => p.id !== this.user.plan.id
          )
        }
      }
      this.isLoadingChangePlan = false
    },
    async updatePlan() {
      this.error = null
      this.isLoadingChangePlan = true
      this.confirmPlanDialog = false
      const [err] = await to(
        this.$store.dispatch(SESSION_UPDATE_PLAN, this.selectedPlan)
      )

      if (err) {
        this.error = this.$t('errors.unknownError')
      } else {
        this.$noty.success(`El plan se ha actualizado correctamente`)
        this.handleCloseChangePlanModal()
        await this.getPendingPayment(null)
        await this.fetchAvailablePlans()
      }

      this.isLoadingChangePlan = false
    },
    paymentGateway(gateway) {
      return `${paymentGateways[gateway]}`
    },
    paymentStatus(status) {
      return `${paymentStatus[status]}`
    },
    formatCurrency(value) {
      return this.$options.filters.thousands(value)
    },
    isStrNegative(string) {
      const result = /^-/.test(string)
      return result
    },
    walletText(balance) {
      const result = !this.isStrNegative(balance)
        ? 'Saldo por pagar de wallet'
        : 'Saldo a favor de wallet'
      return result
    },
    askPaymentConfirmation(method) {
      this.selectedPaymentMethod = method
      this.confirmPaymentMethodDialog = true
    },
    async getPendingPayment(rechargeAmount) {
      this.isLoadingUpdateRechargeWallet = true
      this.error = null
      const [err, data] = await to(
        PaymentService.getPendingPayment(rechargeAmount)
      )
      if (err) {
        this.error = this.$t('errors.unknownError')
      } else {
        const paymentData = pathOr(null, ['data', 'data', 'payment'], data)
        this.$store.commit(SESSION_SET_PAYMENT, paymentData)
      }
      this.isLoadingUpdateRechargeWallet = false
    },
    handleCloseAddRechargeWalletModal() {
      this.showAddRechargeWalletModal = false
      this.rechargeAmount = null
      this.error = null
    },
    handleOpenAddRechargeWalletModal() {
      this.showAddRechargeWalletModal = true
      this.error = null
    },
    async confirmAddRechargeWallet() {
      await this.getPendingPayment(this.rechargeAmount)
      this.$noty.success(`Se agregó la recarga de wallet`)
      this.showAddRechargeWalletModal = false
    },
    async handleRemoveRechargeWallet() {
      await this.getPendingPayment(null)
      this.rechargeAmount = null
      this.$noty.success(`Se removió la recarga de wallet`)
    }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
.text-h2 {
  font-size: 3.5rem !important;
}
</style>
<style lang="scss" scoped>
.text-h2 {
  font-size: 3.5rem !important;
}
.text-title {
  font-weight: 400 !important;
  font-size: 1.5rem;
}
.success-icon {
  background-color: rgba(146, 72, 249, 0.1);
}
.error-icon {
  background-color: rgba(255, 56, 104, 0.1);
}
</style>
